import React, { useEffect, useState } from 'react';

import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';

import Chart, {
  ValueAxis,
  ArgumentAxis,
  CommonPaneSettings,
  Grid,
  Series,
  Label,
  Legend,
  Size,
  Border,
  Tooltip,
  Export,
  LoadingIndicator
} from 'devextreme-react/chart';

import SelectBox from 'devextreme-react/select-box';

import { years } from './data.js';
import http from '../../utils/http.js';
import { formatToMoney, getMonthName } from '../../utils/common';
import Title from '../../components/shared/Title.jsx';
import BlockHeader from '../../components/shared/BlockHeader.jsx';
import { chartTypes, palettes } from '../../data/app.js';

const BillsByMonth = props => {

  const [type, setType] = useState('line');
  const [palette, setPalette] = useState('Material');
  const [data, setData] = useState([]);
  const [year, setYear] = useState(0);
  const [total, setTotal] = useState(0);

  const onValueChanged = e => setYear(e.value);

  useEffect(() => {

    http(`reports/bills/sales?year=${year}`).asGet().then(resp => {

      const dat = resp.map(x => {
        x.mes = getMonthName(x.datemonth);
        return x;
      })

      setData(dat);
      setTotal(resp.reduce((a, b) => a + b.total, 0));

    });

  }, [year]);

  const customizeLabel = (e) => `${e.valueText}`;


  function customizeTooltip(arg) {
    return {
      text: `C$ ${arg.valueText}`
    };
  }

  const title = 'Reporte de ventas por mes';

  return (
    <div className="container">
      <Title title={title} />
      <BlockHeader title={title}>
        <span>Estilo: </span>
        <SelectBox
          text='Seleccione'
          items={chartTypes}
          defaultValue={'line'}
          onValueChanged={e => setType(e.value)} />
        <span>Tema: </span>
        <SelectBox
          text='Seleccione'
          items={palettes}
          defaultValue={'Material'}
          onValueChanged={e => setPalette(e.value)} />
      </BlockHeader>
      <div id="chart-demo">
        <div className="action">
          <div className="label">Seleccione un año:
          </div>
          <SelectBox
            id="selectbox"
            width={150}
            items={years}
            defaultValue={0}
            onValueChanged={onValueChanged} />
        </div>
        <Chart
          title={`Ventas de año ${year}`} palette={palette}
          dataSource={data}>
          <Size height={420} />
          <ValueAxis
            grid={{ opacity: 0.2 }}
            valueType="numeric"
          >
            <Label customizeText={customizeLabel} />
          </ValueAxis>
          <ArgumentAxis type="discrete">
            <Grid visible={true} opacity={0.5} />
          </ArgumentAxis>
          <CommonPaneSettings>
            <Border
              visible={true}
              width={2}
              top={false}
              right={false}
            />
          </CommonPaneSettings>
          <Series
            argumentField="mes"
            valueField="total"
            type={type}
          />
          <Legend visible={false} />
          <Export enabled={true} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip} />
          <LoadingIndicator enabled={true} />
        </Chart>

        <div className="action">
          <div className="label">Total: {formatToMoney(total)}</div>
        </div>
      </div>
    </div>);

}



export default BillsByMonth;
